import { render, staticRenderFns } from "./AuditFileDetail.vue?vue&type=template&id=40d4f10c"
import script from "./AuditFileDetail.vue?vue&type=script&lang=js"
export * from "./AuditFileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports